/* src/app/components/delivery-not-available-modal/delivery-not-available-modal.component.scss */
h1 {
  margin-top: 10px;
}
.button-container .action-btn {
  border-radius: 0;
  width: 50%;
  margin-right: 10px;
  text-align: center;
  padding: 15px;
  background: var(--ion-color-second);
  color: var(--ion-color-main);
}
.button-container .action-btn.negative {
  margin-right: 0;
  margin-left: 10px;
  background: #e2e2e2;
}
/*# sourceMappingURL=delivery-not-available-modal.component.css.map */
